import { PATH_AUTH } from "config";
import { authClient } from "lib/auth-client";
import { ServerError } from "utils/genericUtilityFunctions";

function buildEmailVerificationCallbackUrl(): string {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}${PATH_AUTH.emailVerification}/verified`;
}

function mapBetterAuthVerificationError(error: {
  status?: number;
  message?: string;
  code?: string;
}): ServerError {
  const message = error.message ?? "Failed to send verification email";
  const normalizedMessage = message.toLowerCase();

  if (error.code === "EMAIL_ALREADY_VERIFIED" || normalizedMessage.includes("already verified")) {
    return new ServerError(error.status ?? 400, message, undefined, "EMAIL_ALREADY_VERIFIED", {
      verified: true,
    });
  }

  if (error.code === "RATE_LIMITED" || normalizedMessage.includes("rate limit")) {
    return new ServerError(error.status ?? 429, message, undefined, "RATE_LIMITED");
  }

  if (error.code) {
    return new ServerError(error.status ?? 400, message, undefined, error.code);
  }

  return new ServerError(error.status ?? 400, message);
}

export async function resendBetterAuthVerificationEmail(
  email: string,
  turnstileHeaders?: Record<string, string>
): Promise<{ message: string; data?: { verified?: boolean } }> {
  const result = await authClient.sendVerificationEmail(
    {
      email,
      callbackURL: buildEmailVerificationCallbackUrl(),
    },
    {
      headers: turnstileHeaders,
    }
  );

  if (result.error) {
    throw mapBetterAuthVerificationError(result.error);
  }

  return {
    message: `Verification link has been sent to ${email}`,
  };
}
